<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div :class="bodyClassName">
      <div class="row">
        <div class="col-md-12">
          <h3>
            <button v-if="isFloatingReceiptAvailable" class="pull-right newSelector btn btn-success addbutton agenda-add" type="button" v-on:click="newOrder"><i class="fa fa-fw fa-plus"></i> {{ _('Create new...') }}</button>
            <template v-if="selectedProductName">
              <button class="btn btn-default pull-right" v-on:click="selectProduct(null)"><i class="fa fa-fw fa-arrow-left"></i> {{ _('Return') }}</button><i class="fa fa-fw fa-list-ol"></i> {{ _('Agenda') }}: {{ selectedProductName }}
            </template>
            <template v-else>
              <i class="fa fa-fw fa-list-ol"></i> {{ _('Agenda') }}
            </template>
          </h3>
        </div>
      </div>
      <div class="range-selector agenda-range" v-if="dateStart">
        <div class="range-column day">
          <div class="form-group">
            <div style="display: flex">
              <button type="button" class="btn btn-default btn-xs" v-on:click="moveBack"><i class="fa fa-arrow-left"></i></button>
              <DatePicker v-model="dateStart" v-on:change="inputDateStart" :shortLocale="shortLocale" :staticInput="true"></DatePicker>
              <button type="button" class="btn btn-default btn-xs" v-on:click="moveForward"><i class="fa fa-arrow-right"></i></button>
              <button class="btn btn-default" type="button" v-on:click="setToday">{{ _('Today') }}</button>
            </div>
          </div>
        </div>
        <div class="range-column duration">
          <div class="form-group">
            <select class="form-control" v-model="duration">
              <option value="1d">{{ _('One day') }}</option>
              <option value="2d">{{ _('Two days') }}</option>
              <option value="3d">{{ _('Three days') }}</option>
              <option value="1w">{{ _('One week') }}</option>
              <option value="2w">{{ _('Two weeks') }}</option>
              <option value="1M">{{ _('One month') }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="agenda-list" v-if="showStarting && starting && starting.length">
        <h3>{{ _('Starting reservations') }}</h3>
        <div class="row" v-for="day in starting">
          <div class="col-md-12">
            <div class="agenda-title"><h3>{{ DateTime.fromSeconds(Number(day.ts), { zone: timezone, locale: shortLocale }).toFormat(_('EEEE') + ' ' + dateFormat) }}</h3></div>
            <div class="agenda-times" v-for="time in day.times">
              <div class="agenda-timeheader">
                <div class="agenda-time">{{ DateTime.fromSeconds(Number(time.ts), { zone: timezone }).toFormat(timeFormat) }}</div>
                <div class="agenda-allparticipants">{{ _('Orders') }}: {{ time.orders }}, {{ _('Participants') }}: {{ time.participants }}</div>
                <div v-if="false"></div>
              </div>
              <div class="agenda-items" v-for="item in time.items">
                <div :class="agendaItemClass(item)">
                  <div class="agenda-col agenda-col-1">
                    <div class="agenda-timerange">{{ DateTime.fromSeconds(Number(item.start_ts), { zone: timezone }).toFormat(timeFormat) }} - {{ DateTime.fromSeconds(Number(item.end_ts), { zone: timezone }).toFormat(timeFormat) }}</div>
                    <div class="agenda-product" v-if="!selectedProductName"><span><a href="javascript:;" v-on:click="selectProduct(item.product_id)">{{ item.product_name }}</a><span class="reservation-desc" v-if="item.reservation_desc"><br>{{ getReservationDesc(item) }}</span></span> <button v-if="isFloatingReceiptAvailable" class="btn btn-default btn-xs btn-addproduct" type="button" v-on:click="addProduct(item.product_id, day.ts)"><i class="fa fa-fw fa-plus"></i></button></div>
                    <div class="agenda-checkin">
                      <button v-if="!item.checkin_ts" type="button" class="btn btn-xs btn-success" v-on:click="checkIn(item)"><i class="fa fa-fw fa-sign-in"></i> {{ _('Check in') }}</button>
                      <button v-else type="button" class="btn btn-xs btn-default" v-on:click="cancelCheckIn(item)"><i class="fa fa-fw fa-check"></i> {{ _('Checked in') }} {{ $filters.timestampToDate(item.checkin_ts) }} {{ _('at') }} {{ $filters.timestampToTime(item.checkin_ts) }}</button>
                      <lock-info v-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getOrderComponentLock(item.order_id)" />
                      <button v-else-if="isOrderEditable(item)" class="btn btn-xs btn-primary" v-on:click="editOrder(item.order_id)" :disabled="loading ? 'disabled' : false"><i class="fa fa-fw fa-edit"></i> {{ _('Edit order') }}</button>
                    </div>
                  </div>
                  <div class="agenda-col agenda-col-2">
                    <div class="agenda-clients">
                      <div class="agenda-client"><a href="javascript:;" v-on:click="editReservation(item.reservation_id, item.order_id, item.name)">{{ item.name }}</a></div>
                      <div class="agenda-participants" v-if="item.pricetiers">{{ getPricetierDescription(item) }}</div>
                    </div>
                    <div class="agenda-notes">
                      <button v-if="item.more || item.notes" type="button" class="btn btn-xs btn-info" v-on:click.prevent.stop="notesClicked(item)"><i class="fa fa-fw fa-sticky-note"></i></button>
                    </div>
                    <div class="agenda-col-2-2">
                      <div class="agenda-resources">
                        <span class="resource-item" v-for="resource in item.resources">{{ resource.name }}: <strong>{{ resource.seats }}</strong></span>
                      </div>
                      <div class="agenda-participants"><strong>{{ item.participants }}</strong></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="agenda-list" v-if="showEnding && ending && ending.length">
        <h3>{{ _('Ending reservations') }}</h3>
        <div class="row" v-for="day in ending">
          <div class="col-md-12">
            <div class="agenda-title"><h3>{{ DateTime.fromSeconds(Number(day.ts), { zone: timezone, locale: shortLocale }).toFormat(_('EEEE') + ' ' + dateFormat) }}</h3></div>
            <div class="agenda-times" v-for="time in day.times">
              <div class="agenda-timeheader">
                <div class="agenda-time">{{ DateTime.fromSeconds(Number(time.ts), { zone: timezone }).toFormat(timeFormat) }}</div>
                <div class="agenda-allparticipants">{{ _('Orders') }}: {{ time.orders }}, {{ _('Participants') }}: {{ time.participants }}</div>
                <div v-if="false"></div>
              </div>
              <div class="agenda-items" v-for="item in time.items">
                <div :class="agendaItemClass(item)">
                  <div class="agenda-col agenda-col-1">
                    <div class="agenda-timerange">{{ DateTime.fromSeconds(Number(item.start_ts), { zone: timezone }).toFormat(timeFormat) }} - {{ DateTime.fromSeconds(Number(item.end_ts), { zone: timezone }).toFormat(timeFormat) }}</div>
                    <div class="agenda-product" v-if="!selectedProductName"><span><a href="javascript:;" v-on:click="selectProduct(item.product_id)">{{ item.product_name }}</a><span class="reservation-desc" v-if="item.reservation_desc"><br>{{ getReservationDesc(item) }}</span></span> <button v-if="isFloatingReceiptAvailable" class="btn btn-default btn-xs btn-addproduct" type="button" v-on:click="addProduct(item.product_id, day.ts)"><i class="fa fa-fw fa-plus"></i></button></div>
                    <div class="agenda-checkin">
                      <button v-if="!item.checkout_ts" type="button" class="btn btn-xs btn-info" v-on:click="checkOut(item)" :disabled="item.checkin_ts ? false : 'disabled'"><i class="fa fa-fw fa-sign-out"></i> {{ _('Check out') }}</button>
                      <button v-else type="button" class="btn btn-xs btn-default" v-on:click="cancelCheckOut(item)"><i class="fa fa-fw fa-check"></i> {{ _('Checked out') }} {{ $filters.timestampToDate(item.checkout_ts) }} {{ _('at') }} {{ $filters.timestampToTime(item.checkout_ts) }}</button>
                      <lock-info v-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getOrderComponentLock(item.order_id)" />
                      <button v-else-if="isOrderEditable(item)" class="btn btn-xs btn-primary" v-on:click="editOrder(item.order_id)" :disabled="loading ? 'disabled' : false"><i class="fa fa-fw fa-edit"></i> {{ _('Edit order') }}</button>
                    </div>
                  </div>
                  <div class="agenda-col agenda-col-2">
                    <div class="agenda-clients">
                      <div class="agenda-client"><a href="javascript:;" v-on:click="editReservation(item.reservation_id, item.order_id, item.name)">{{ item.name }}</a></div>
                      <div class="agenda-participants" v-if="item.pricetiers">{{ getPricetierDescription(item) }}</div>
                    </div>
                    <div class="agenda-notes">
                      <button v-if="item.more || item.notes" type="button" class="btn btn-xs btn-info" v-on:click.prevent.stop="notesClicked(item)"><i class="fa fa-fw fa-sticky-note"></i></button>
                    </div>
                    <div class="agenda-col-2-2">
                      <div class="agenda-resources">
                        <span class="resource-item" v-for="resource in item.resources">{{ resource.name }}: <strong>{{ resource.seats }}</strong></span>
                      </div>
                      <div class="agenda-participants"><strong>{{ item.participants }}</strong></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="agenda-list" v-if="showOngoing && ongoing && ongoing.length">
        <h3>{{ _('Ongoing reservations') }}</h3>
        <div class="row">
          <div class="col-md-12">
            <div class="agenda-timeheader">
              <div class="agenda-time">&nbsp;</div>
            </div>
            <div class="agenda-items" v-for="item in ongoing">
              <div :class="agendaItemClass(item)">
                <div class="agenda-col agenda-col-1">
                  <div class="agenda-timerange-withdates">{{ DateTime.fromSeconds(Number(item.start_ts), { zone: timezone }).toFormat(dateFormat) }} {{ _('at') }} {{ DateTime.fromSeconds(Number(item.start_ts), { zone: timezone }).toFormat(timeFormat) }} - {{ DateTime.fromSeconds(Number(item.end_ts), { zone: timezone }).toFormat(dateFormat) }} {{ _('at') }} {{ DateTime.fromSeconds(Number(item.end_ts), { zone: timezone }).toFormat(timeFormat) }}</div>
                  <div class="agenda-product" v-if="!selectedProductName"><span><a href="javascript:;" v-on:click="selectProduct(item.product_id)">{{ item.product_name }}</a><span class="reservation-desc" v-if="item.reservation_desc"><br>{{ getReservationDesc(item) }}</span></span> <button v-if="isFloatingReceiptAvailable" class="btn btn-default btn-xs btn-addproduct" type="button" v-on:click="addProduct(item.product_id, day.ts)"><i class="fa fa-fw fa-plus"></i></button></div>
                </div>
                <div class="agenda-col agenda-col-2">
                  <div class="agenda-clients">
                    <div class="agenda-client"><a href="javascript:;" v-on:click="editReservation(item.reservation_id, item.order_id, item.name)">{{ item.name }}</a></div>
                    <div class="agenda-participants" v-if="item.pricetiers">{{ getPricetierDescription(item) }}</div>
                  </div>
                  <div class="agenda-notes">
                      <button v-if="item.more || item.notes" type="button" class="btn btn-xs btn-info" v-on:click.prevent.stop="notesClicked(item)"><i class="fa fa-fw fa-sticky-note"></i></button>
                    </div>
                  <div class="agenda-col-2-2">
                    <div class="agenda-resources">
                      <span class="resource-item" v-for="resource in item.resources">{{ resource.name }}: <strong>{{ resource.seats }}</strong></span>
                    </div>
                    <div class="agenda-participants"><strong>{{ item.participants }}</strong></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="!hasVisibleReservations">
        <div class="col-md-12">
          <p>{{ _('No reservations.') }}</p>
        </div>
      </div>
      <p>&nbsp;</p>
      <ReservableProductListItem v-if="product" :column="column" :activeComponent="component" :baseDomain="baseDomain" :key="product.id" :product="product" :productShopId="productShopId" :auto="true" :allowResourceSelection="true" :preselectedResource="preselectedResource" :defaultStartDate="productStartDate" :defaultEndDate="productEndDate" v-on:productModalClosed="productModalClosed">
      {{ product.name }}
      </ReservableProductListItem>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'

export default {
  data () {
    let $this = this
    return {
      DateTime: DateTime,
      componentId: null,
      selectedProductIds: [],
      agenda: [],
      pricetiers: [],
      range: {},
      duration: '1d',
      product: null,
      productShopId: null,
      productStartDate: null,
      productEndDate: null,
      preselectedResource: null,
      loadingOrder: false,
      activeOrderId: false
    }
  },
  mixins: [components],
  computed: {
    ...mapGetters(['locale']),
    shortLocale () {
      return this.locale.split('_')[0]
    },
    starting () {
      return this.agenda && this.agenda.starting ? this.agenda.starting : []
    },
    ending () {
      return this.agenda && this.agenda.ending ? this.agenda.ending : []
    },
    ongoing () {
      return this.agenda && this.agenda.ongoing ? this.agenda.ongoing : []
    },
    componentData () {
      if (this.component && this.component.data) {
        try {
          return JSON.parse(this.component.data)
        } catch (e) {
          return {}
        }
      }
      return {}
    },
    reservationMode () {
      const mode = this.componentData.mode
      if (mode === 'starting' || mode === 'ending') {
        return mode
      }
      return 'all'
    },
    showStarting () {
      return this.reservationMode === 'all' || this.reservationMode === 'starting'
    },
    showEnding () {
      return this.reservationMode === 'all' || this.reservationMode === 'ending'
    },
    showOngoing () {
      return this.reservationMode === 'all'
    },
    hasVisibleReservations () {
      return (this.showStarting && this.starting.length) || (this.showEnding && this.ending.length) || (this.showOngoing && this.ongoing.length)
    },
    dateStart: {
      get() {
        if (!this.range || !this.range.datestart) {
          return null
        }
        const dt = DateTime.fromFormat(this.range.datestart, this.dateFormat, { zone: this.timezone })
        return new Date(dt.year, dt.month - 1, dt.day, 0, 0, 0)
      },
      set(newValue) {
        if (newValue) {
          this.range.datestart = DateTime.fromJSDate(newValue, { zone: this.timezone }).toFormat(this.dateFormat)
        } else {
          this.range.datestart = null
        }
      }
    },
    start () {
      if (!this.range || !this.range.datestart) {
        return null
      }
      return DateTime.fromFormat(
        this.range.datestart, 
        this.dateFormat, 
        { zone: this.timezone }
      ).toFormat('yyyy-MM-dd')
    },
    end () {
      if (!this.dateStart) {
        return null
      }
      const len = this.duration.charAt(0)
      let dur = this.duration.charAt(1)
      switch (dur) {
        case 'd':
          dur = 'days'
          break
        case 'w':
          dur = 'weeks'
          break
        case 'M':
          dur = 'months'
          break
      }
      return DateTime.fromJSDate(this.dateStart).plus({ [dur]: Number(len) }).toFormat('yyyy-MM-dd')
    },
    products () {
      if (this.componentData.products) {
        return this.componentData.products.map(r => r.id)
      }
      return []
    },
    selectedProductName () {
      let name
      if (this.selectedProductIds && this.selectedProductIds.length === 1 && this.agenda) {
        name = this.getProductName(this.agenda.starting)
        if (!name) {
          name = this.getProductName(this.agenda.ending)
        }
        if (!name) {
          name = this.agenda.ongoing && this.agenda.ongoing[0] && this.agenda.ongoing[0].product_name ? this.agenda.ongoing[0].product_name : null
        }
        return name
      }
      return null
    },
    reservationIds () {
      if (!this.agenda) {
        return []
      }
      const ids = {}
      this.agenda.starting.forEach(a => {
        if (a.times) {
          a.times.forEach(t => {
            if (t.items) {
              t.items.forEach(i => {
                ids[i.reservation_id] = true
              })
            }
          })
        }
      })
      this.agenda.ending.forEach(a => {
        if (a.times) {
          a.times.forEach(t => {
            if (t.items) {
              t.items.forEach(i => {
                ids[i.reservation_id] = true
              })
            }
          })
        }
      })
      this.agenda.ongoing.forEach(i => {
        ids[i.reservation_id] = true
      })
      return Object.keys(ids)
    }
  },
  methods: {
    getOrderComponentLock (orderId) {
      this.activeOrderId = orderId
      this.getComponentLock(true)
    },
    getComponentItemId () {
      return this.activeOrderId
    },
    getReservationDesc (reservation) {
      let s = ''
      const _ = this._
      const sd = DateTime.fromSeconds(Number(reservation.start_ts), { zone: this.timezone })
      let ed = DateTime.fromSeconds(Number(reservation.end_ts), { zone: this.timezone })
      let et = ed.toFormat(this.timeFormat)
      if (et === '0.00') {
        et = '24.00'
        ed = ed.minus({ days: 1 })
      }
      s += sd.toFormat(this.dateFormat) + ' ' + _('at') + ' ' + sd.toFormat(this.timeFormat)
      s += ' - '
      if (sd.toFormat('yyyy/MM/dd') !== ed.toFormat('yyyy/MM/dd')) {
        s += ed.toFormat(this.dateFormat) + ' ' + _('at') + ' '
      }
      s += et
      return s
    },
    checkIn(item) {
      this.checkInOrOut(item, 'in')
    },
    checkOut(item) {
      this.checkInOrOut(item, 'out')
    },
    cancelCheckIn(item) {
      this.checkInOrOut(item, 'in', true)
    },
    cancelCheckOut(item) {
      this.checkInOrOut(item, 'out', true)
    },
    async checkInOrOut(item, mode, cancel) {
      let data = {
        identifier: item.identifier
      }
      if (mode === 'in') {
        if (cancel) {
          data.checkin_ts = null
        } else {
          data.checkin_ts = 'now'
        }
      } else {
        if (cancel) {
          data.checkout_ts = null
        } else {
          data.checkout_ts = 'now'
        }
      }
      let response
      try {
        response = await axios.patch(this.baseDomain + this.shopId + '/reservations/' + item.identifier + '.json?apikey=' + this.apiKey, data)
      } catch(e) {}
      const updateItems = (items) => {
        if (items && items.times) {
          items.times.forEach(time => {
            if (time.items) {
              time.items.forEach(i => {
                if (i.identifier === item.identifier) {
                  i.checkin_ts = item.checkin_ts
                  i.checkout_ts = item.checkout_ts
                }
              })
            }
          })
        }
      }
      await this.loadReservation(item)
      this.agenda.starting.forEach(updateItems)
      this.agenda.ongoing.forEach(updateItems)
      this.agenda.ending.forEach(updateItems)
    },
    async loadReservation (item) {
      let response
      let id = item.identifier
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/reservations/' + id + '.json?items=true&resources=true&seats=true&pin=true&apikey=' + this.apiKey)
      } catch (e) {
        this.showError(e)
        return
      }
      item.checkin_ts = response.data.checkin_ts
      item.checkout_ts = response.data.checkout_ts
    },
    getProductName(parent) {
      if (parent && parent.length && parent[0] && parent[0].times && parent[0].times[0] && parent[0].times[0].items && parent[0].times[0].items[0]) {
        return parent[0].times[0].items[0].product_name
      }
      return null
    },
    async addProduct (id, ts) {
      this.productShopId = this.shopId
      this.productStartDate = DateTime.fromSeconds(Number(ts), { zone: this.timezone }).toJSDate()
      // this.productStartDate = null
      this.productEndDate = null
      this.preselectedResource = null
      this.product = await this.loadProduct(id)
    },
    productModalClosed () {
      this.productShopId = null
      this.product = null
      this.productStartDate = null
      this.productEndDate = null
      this.preselectedResource = null
    },
    moveBack () {
      this.range.datestart = DateTime.fromFormat(this.start, 'yyyy-MM-dd', { zone: this.timezone }).minus({ days: 1 }).toFormat(this.dateFormat)
    },
    moveForward () {
      this.range.datestart = DateTime.fromFormat(this.start, 'yyyy-MM-dd', { zone: this.timezone }).plus({ days: 1 }).toFormat(this.dateFormat)
    },
    setToday () {
      this.range.datestart = DateTime.now({ zone: this.timezone }).toFormat(this.dateFormat)
    },
    inputDateStart(newValue) {
      this.input('datestart', newValue)
    },
    input (prop, newValue) {
      if (!(newValue instanceof Date)) {
        return
      }
      this.range[prop] = DateTime.fromJSDate(newValue, { zone: this.timezone }).toFormat(this.dateFormat)
    },
    newOrder () {
      this.EventBus.$emit('showFloatingReceipt')
    },
    isOrderEditable(item) {
      return this.floatingReceipt && item.payment === 'open' && !!(item.confirmed)
    },
    loadOrder (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/orders/' + id + '.json?items=true&reservations=true&bamboraid=true&messages=true&apikey=' + this.apiKey)
        } catch (e) {
          this.loading = false
          this.showError(e)
          reject()
          return
        }
        this.loading = false
        resolve(response.data)
      })
    },
    async editOrder (orderId) {
      this.activeOrderId = orderId
      this.getComponentLock()
      let order = await this.loadOrder(orderId)
      if (!order) {
        this.releaseComponentLock()
        this.activeOrderId = false
        return
      }
      this.EventBus.$emit('modifyOrder', {
        order
      })
    },
    editReservation (id, orderId, name, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'ReservationDetails',
        title: this._('Reservation') + ': ' + id + (name ? ': ' + name : ''),
        data: {
          reservationId: id,
          orderId: orderId
        },
        skipState
      })
    },
    selectProduct (id) {
      if (id) {
        this.selectedProductIds = [id]
      } else {
        this.selectedProductIds = []
      }
    },
    agendaItemClass (item) {
      let extra = ''
      if (item) {
        if (item.payment === 'open') {
          extra = ' agenda-item-open'
        } else if (parseInt(item.confirmed) === 1) {
          extra = ' agenda-item-confirmed'
        } else if (parseInt(item.paid) === 0) {
          extra = ' agenda-item-notpaid'
        }
      }
      return 'agenda-item' + extra
    },
    getPricetierDescription (item) {
      if (!this.pricetiers.length) {
        return ''
      }
      const tiers = item.pricetiers.split(';')
      let ret = []
      for (let i = 0; i < tiers.length; i++) {
        let [id, count] = tiers[i].split(':')
        const pt = this.pricetiers.find(p => parseInt(p.id, 10) === parseInt(id, 10))
        if (pt) {
          ret.push(pt.name + ': ' + count)
        }
      }
      return ret.join(', ')
    },
    load () {
      return new Promise(async (resolve, reject) => {
        let response
        let productStr = ''
        if (this.selectedProductIds && this.selectedProductIds.length) {
          productStr = '&products=' + this.selectedProductIds.join(',')
        } else if (this.products && this.products.length) {
          productStr = '&products=' + this.products.join(',')
        }
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/agenda.json?start=' + this.start + '&end=' + this.end + '&mode=all&apikey=' + this.apiKey + productStr)
        } catch(e) {
          this.showError(e)
          resolve()
          return
        }
        resolve(response.data)
      })
    },
    loadPricetiers () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/pricetiers.json?apikey=' + this.apiKey)
        } catch(e) {
          this.showError(e)
          resolve()
          return
        }
        resolve(response.data)
      })
    },
    loadProduct (id) {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/products/' + id + '.json?apikey=' + this.apiKey)
        } catch (e) {
          this.showError(e)
          reject(e)
          return
        }
        resolve(response.data)
        return
      })
    },
    notesClicked (item) {
      this.EventBus.$emit('displayNotes', {
        type: 'order',
        transaction: {
          id: item.order_id,
          more: item.more,
          notes: item.notes
        }
      })
    }
  },
  watch: {
    async end () {
      this.agenda = await this.load()
    },
    selectedProductIds: {
      deep: true,
      async handler () {
        this.agenda = await this.load()
      }
    }
  },
  async updated () {
    if (this.component && this.componentId !== this.component.id) {
      this.componentId = this.component.id
      this.productModalClosed()
      if (this.selectedProductIds.length) {
        this.selectedProductIds = [] // Triggers a reload via the watcher above
      } else {
        this.agenda = await this.load()
      }
    }
  },
  beforeUnmount () {
    if(this.activeOrderId) {
      this.releaseComponentLock()
      this.activeOrderId = false
    }
  },
  async mounted () {
    this.loadingOrder = false
    this.activeOrderId = false
    this.componentId = this.component ? this.component.id : null
    this.setToday()
    this.agenda = await this.load()
    this.pricetiers = await this.loadPricetiers()
    if(!this.events) {
      let events = {}
      events['availabilityUpdate'] = async (message) => {
        if (message.data && message.data.reservationId && this.reservationIds && this.reservationIds.includes(message.data.reservationId)) {
          this.agenda = await this.load()
        }
      }
      /*
      events['productUpdate'] = debounce((message) => {
        return this.reload()
      }, 200)
      events['categoryUpdate'] = debounce((message) => {
        return this.reload()
      }, 200)
      */
      this.events = events
    }
    this.enableEventBus()
  }
}

</script>

<style scoped>

</style>